import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73894211"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "server-select-root" }
const _hoisted_2 = {
  action: "",
  class: "form"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, null, -1))
const _hoisted_4 = { class: "form-wrap" }
const _hoisted_5 = { class: "form-title" }
const _hoisted_6 = { class: "form-info" }
const _hoisted_7 = { class: "p1" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "btn-group" }
const _hoisted_10 = { class: "btn-label" }
const _hoisted_11 = { class: "btn-icon" }
const _hoisted_12 = { class: "btn-label" }
const _hoisted_13 = { class: "btn-icon" }
const _hoisted_14 = { class: "btn-label" }
const _hoisted_15 = { class: "btn-icon" }
const _hoisted_16 = { class: "input-group" }
const _hoisted_17 = ["placeholder"]
const _hoisted_18 = { class: "btn-label" }
const _hoisted_19 = { class: "label" }
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"footer\" data-v-73894211><div class=\"image-wrap\" data-v-73894211><div class=\"fc\" data-v-73894211></div><div class=\"ceza\" data-v-73894211></div></div><div class=\"footer-text\" data-v-73894211> 本公司领有菲律宾合法网上娱乐场牌照 (Interacrive Gaming Licence) Copyright 利博娱乐场 </div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_lines = _resolveComponent("icon-lines")!
  const _component_icon_service = _resolveComponent("icon-service")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", {
        class: "language",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectLanguage && _ctx.selectLanguage(...args)))
      }, _toDisplayString(_ctx.language), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.t('serverselection.lineSelection')), 1),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", _hoisted_7, [
            _createTextVNode(_toDisplayString(_ctx.t('serverselection.p1')) + " ", 1),
            _createVNode(_component_icon_lines, {
              class: "icon-check",
              active: true
            }),
            _createTextVNode(_toDisplayString(_ctx.t('serverselection.p2')), 1),
            _createVNode(_component_icon_lines, { class: "icon-x" }),
            _createTextVNode(" " + _toDisplayString(_ctx.t('serverselection.p3')) + " " + _toDisplayString(_ctx.t('serverselection.p4')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", {
              class: _normalizeClass(["btn", { disabled: !_ctx.line1 }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clickLine(1)))
            }, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.t('serverselection.line1')), 1),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_icon_lines, { active: _ctx.line1 }, null, 8, ["active"])
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["btn", { disabled: !_ctx.line2 }]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clickLine(2)))
            }, [
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.t('serverselection.line2')), 1),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_icon_lines, { active: _ctx.line2 }, null, 8, ["active"])
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["btn", { disabled: !_ctx.line3 }]),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clickLine(3)))
            }, [
              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.t('serverselection.line3')), 1),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_icon_lines, { active: _ctx.line3 }, null, 8, ["active"])
              ])
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: _ctx.t('serverselection.customline'),
              class: "input",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.serverStr) = $event))
            }, null, 8, _hoisted_17), [
              [
                _vModelText,
                _ctx.serverStr,
                void 0,
                { trim: true }
              ]
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["btn", { disabled: _ctx.serverStr.length <= 0 }]),
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.enterLogin && _ctx.enterLogin(...args)))
            }, [
              _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.t('serverselection.enter')), 1)
            ], 2)
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: "customer-service",
        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.contactService && _ctx.contactService(...args)))
      }, [
        _createVNode(_component_icon_service, {
          "fill-color": '#e0d77f',
          class: "icon"
        }),
        _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.t('menu.cutomerservice')), 1)
      ])
    ]),
    _hoisted_20
  ]))
}